module.exports = require("./fr-BI.js");